import React from 'react';
import ReactDOM from 'react-dom';
import { initApi } from './helpers/api';
import App from './App';
import store from './store';

initApi(store)
  .then(() => {
    ReactDOM.render(<App />, document.getElementById('root'));
  })
  .catch(err => {
    console.error(err); // eslint-disable-line no-console
  });
